
import { Component, Vue } from "vue-property-decorator";
import AuthenticCard from "../shared/AuthenticCard.vue";
import AvatarSelector from "../shared/AvatarSelector.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { getValidationState, validateContext } from "../../utils/Validation";
import { addUser } from "../../services/UserService";
import User from "../../models/User";

@Component({
  components: {
    AuthenticCard,
    ValidationObserver,
    ValidationProvider,
    AvatarSelector,
  },
})
export default class Register extends Vue {
  get user(): User {
    return this.$store.getters.authUser;
  }
  title = "Register";
  userPassword = "";
  userConfirmPassword = "";
  vertAlignment = "align-self-top";

  invitedUser: Partial<User> = {};

  mounted() {
    this.invitedUser!.email = this.$route.query.email as string;
    this.invitedUser!.role = this.$route.query.role as string;
    this.invitedUser!.companyId = Number(this.$route.query.companyId);
    this.invitedUser!.avatar = "bot1.jpg";
    //TODO avatar selector needs this but should adjust it to be more robust.
    this.$store.commit("authUser", this.invitedUser);
  }

  close() {
    this.$router.push({ name: "login" });
  }

  validate(context: validateContext) {
    return getValidationState(context);
  }

  async submit() {
    try {
      const payLoad = {
        ...this.user,
        password: this.userPassword,
        password_confirmation: this.userConfirmPassword,
      };
      await addUser(payLoad);
      this.$root.$emit(
        "alertSuccess",
        "Account has been successfully registered"
      );
      this.$router.push({ name: "login",  params: { email: this.user.email } });
    } catch (error) {
      this.$root.$emit(
        "alertError",
        "Error in registering account, please try again."
      );
      console.log("Error registering account: " + error);
    }
  }
}
